export default {
    setNewsletterMailingData(state, newsletterMailingData) {
        state.newsletterMailingData = newsletterMailingData
    },

    setSubscriberToken(state, subscriberToken) {
        state.subscriberToken = subscriberToken
    },

    setNewsletterMailingIsLoaded(state, isLoaded) {
        state.newsletterMailingIsLoaded = isLoaded
    }
}
